import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@stenpro/ui-components';

export function RequireAuth({ children }: { children: React.ReactElement }) {
  const { state } = useAuthContext();
  return state.isAuthenticated ? children : <Navigate to="/login" replace />;
}
